
import { mapState } from "vuex";

export default {
  data: () => ({ resizeObserver: null, animationFrame: null }),

  head() {
    return {
      script: [
        { src: this.$config.prismicPreviewURL, body: true, defer: true },
      ],
      meta: [
        {
          name: this.header?.meta_tags?.[0]?.name?.[0]?.text ?? "",
          content: this.header?.meta_tags?.[0]?.content?.[0]?.text ?? "",
        },
      ],
    };
  },

  computed: {
    header() {
      return this.$store.state.prismicHeader || {};
    },
    ...mapState(["siteConfig"]),
    ...mapState("app", [
      "activeMenuIndex",
      "isMegaMenuOpen",
      "isFilterPanelOpen",
      "topBannerHeight",
      "quickviewProduct",
      "isMembershipModalOpen",
    ]),
    ...mapState("wishlist", ["currentModalType", "modalTypes"]),
    informationBannerProps() {
      return {
        banners: this.header?.information_banner,
        fontSize: this.header?.information_banner_font_size,
        textColor: this.header?.information_banner_text_color,
        bannerColor: this.header?.information_banner_color,
        timeInterval: this.header?.information_banner_time_interval,
      };
    },
  },

  mounted() {
    if (window.ResizeObserver == undefined) {
      return;
    }

    this.resizeObserver = new ResizeObserver(entries => {
      // Reference from https://github.com/nolimits4web/swiper/pull/5441/files
      this.animationFrame = window.requestAnimationFrame(() => {
        let entry = entries[0];
        let width;
        if (entry.contentBoxSize) {
          // Checking for chrome as using a non-standard array
          if (entry.contentBoxSize[0]) {
            width = entry.contentBoxSize[0].inlineSize;
          } else {
            width = entry.contentBoxSize.inlineSize;
          }
          this.$store.commit("app/SET_WINDOW_WIDTH", width);
        } else {
          this.$store.commit("app/SET_WINDOW_WIDTH", entry.contentRect.width);
        }
      });
    });
    this.resizeObserver.observe(this.$nuxt.$el, { box: "border-box" });

    this.$store.dispatch(
      "app/currentOrientation",
      window.matchMedia("(orientation: portrait)")
    );
  },

  destroyed() {
    if (this.animationFrame) {
      window.cancelAnimationFrame(this.animationFrame);
    }

    this.resizeObserver?.unobserve(this.$nuxt.$el);
  },
};
